import { render, staticRenderFns } from "./shipperList.vue?vue&type=template&id=36c28f86&scoped=true&"
import script from "./shipperList.vue?vue&type=script&lang=js&"
export * from "./shipperList.vue?vue&type=script&lang=js&"
import style0 from "./shipperList.vue?vue&type=style&index=0&id=36c28f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c28f86",
  null
  
)

export default component.exports